import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'p-progress-bar-dialog',
    template: `<p-progress-bar
        *ngIf="data.value !== undefined"
        [title]="data.title"
        [description]="data.description"
        [value]="data.value"
    ></p-progress-bar>`
})
export class PProgressBarDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<PProgressBarDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { value: number; title?: string; description?: string }
    ) {}
}
